/**
 * WHERE SOL LIVES — every Sol address, in one place. M11 / D-041.
 *
 * **ONE PLACE, for the reason `report-route.ts`, `settings-route.ts` and
 * `sol-capture-route.ts` exist:** a path written twice is a path that can
 * disagree with itself. History, memory, the Global entry and "open this
 * conversation" are all built from here and nowhere else.
 *
 * **THE GLOBAL ENTRY IS THE SAME SOL.** `/sol` mounts the same
 * `SolConversation` with `currentProjectId = null` — one brain, one
 * conversation system, one memory, one set of capabilities (D-041, J-6). The
 * Project entry keeps its Project-shaped address because that is the context
 * it supplies; nothing about the address grants anything.
 *
 * **OPENING A CONVERSATION OPENS IT WHERE IT STARTED.** A Project-origin
 * conversation reopens inside that Project's Sol (so the screen context is the
 * one it was started with); a Global-origin one reopens in Global Sol. The id
 * in the address is an identifier, not a permission: the server loads it as
 * the caller under RLS, and somebody else's id simply begins a fresh
 * conversation.
 */

export const GLOBAL_SOL_PATH = '/sol';
export const SOL_MEMORY_PATH = '/sol/memory';

/** The Sol screen for a Project, or Global Sol when there is none. */
export function solPath(projectId: string | null): string {
  return projectId === null ? GLOBAL_SOL_PATH : `/projects/${projectId}/sol`;
}

/** The conversation history list for one origin. */
export function solHistoryPath(projectId: string | null): string {
  return `${solPath(projectId)}/history`;
}

/** Open ONE conversation where it started — Project Sol or Global Sol. */
export function solConversationPath(projectId: string | null, conversationId: string): string {
  return `${solPath(projectId)}/c/${conversationId}`;
}
